import type { Variant } from '../../codegen/types';
import { getAmount } from '../currencyHelper';
import { findMostExpensiveSku } from '../price';

export function addProductJson(
  name?: string,
  description?: string,
  imageUrls?: string[],
  variants?: Variant[],
  url?: string,
) {
  const mosExpensiveSku = findMostExpensiveSku({ variants });

  return {
    __html: JSON.stringify(
      {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        '@id': url,
        name: name ?? '',
        description: description ?? '',
        image: imageUrls?.[0] ?? '',
        offers: {
          '@type': 'Offer',
          price:
            mosExpensiveSku?.actualPrice.centAmount !== undefined
              ? +getAmount(mosExpensiveSku.actualPrice.centAmount)
              : 0,
          priceCurrency: mosExpensiveSku?.actualPrice.currencyCode ?? '',
          itemCondition: 'https://schema.org/NewCondition',
          availability: variants?.find((item) => item.stock.status === 'inStock')
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock',
        },
      },
      null,
      2,
    ),
  };
}
